module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')])]), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_p01_r1"
    }
  }, [_vm._v("PART ONE - About Green Smoothies")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c01_r1"
    }
  }, [_vm._v("What Are Green Smoothies?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c01_r1#h1"
    }
  }, [_vm._v("What Goes into a Green Smoothie?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c02_r1"
    }
  }, [_vm._v("What’s the Big Deal About Greens?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c02_r1#h1"
    }
  }, [_vm._v("Greens for Salads and Smoothies")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c03_r1"
    }
  }, [_vm._v("Sprouts and Microgreens")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c03_r1#h1"
    }
  }, [_vm._v("Sprouts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c03_r1#h2"
    }
  }, [_vm._v("Microgreens")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And What About Herbs?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basil")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cilantro/Coriander Leaf")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c04_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parsley")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Juice or Blend?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The History of Blending")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What About a Blender?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raw Foods")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Protein Myth")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crazy About Carbs")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c10_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Why Are Green Smoothies Good for Blood Sugar?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Should Fats Go in a Green Smoothie?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c11_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Are the Different Kinds of Fats?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c11_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Do Fats Affect Digestion?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can Green Smoothies Help with Weight Loss?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c12_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Protein/Low-Carb Diet")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c12_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Carb/Low-Fat Diet")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c12_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Low-GI Diet")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c12_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diets with Three or Four Phases")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c12_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raw Food Diet")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hello, Sweetie!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c13_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAQs")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Importance of Variety")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superfoods in Green Smoothies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chia Seeds")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Micro-algae")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bee Pollen")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raw Cacao")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antioxidants")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hemp Seeds")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c15_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Green Alkalising Superfood")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO - Green Smoothie Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c16_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c17_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autumn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c18_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autumn Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winter")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c19_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winter Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antioxidants")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c20_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antioxidant-Boosting Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bones and Joints")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c21_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bone- and Joint-Friendly Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bowel")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c22_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Fiber Recipes to Really Get Things Moving!")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c22_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Smoothies High in Soluble Fiber")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cardiovascular Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c23_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes to Optimize Cardiovascular Health")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cellular Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c24_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cellular Health–Boosting Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Blood Sugar")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c25_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes for Blood-Sugar Maintenance")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weight Loss")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c26_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes to Aid Weight Loss")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happy Hormones")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c27_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hormone-Friendly Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Longevity")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c28_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antiaging Recipes to Start Turning Back the Clock!")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beauty")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c29_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beautifying Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mood")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c30_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mood-Enhancing Green Smoothies")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fertility and Maternal Health")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c31_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pre-Conception and Pregnancy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c31_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes for Before and During Pregnancy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c31_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fertility-Boosting Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Babies and Children")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c32_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Babies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c32_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children over 2 Years Old")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c32_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Probiotics")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c33_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana-less Green Smoothies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c33_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana-less Spring Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c33_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana-less Summer Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c33_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana-less Autumn Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c33_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana-less Winter Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c34_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fructose-Friendly Smoothies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c34_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fructose-Friendly Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c35_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fussy About Fruit")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c36_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superfoods")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c36_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superfood-Packed Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c37_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blended Green Juices")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c37_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blended Juice Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c38_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple and Stunning")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c38_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Smoothie Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c39_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c39_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Recipes")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c40_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Desserts")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_c41_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nut and Seed Milks")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_ap1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kris_9781569759998_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a8366d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kris_9781569759998_oeb_toc_r1.vue
// module id = 63
// module chunks = 0